import { isSupabaseConfigured } from "@/integrations/supabase/supabaseConfig";

export interface AdminPurgeResult {
  readonly ok: boolean;
  readonly reason?: string;
  readonly deletedScopes?: readonly string[];
}

interface PurgeResponseBody {
  readonly ok?: boolean;
  readonly reason?: string;
  readonly result?: string;
  readonly deletedScopes?: readonly string[];
  readonly error?: string;
}

export async function purgeOwnUserData(): Promise<AdminPurgeResult> {
  if (!isSupabaseConfigured()) {
    return { ok: false, reason: "supabase-not-configured" };
  }
  const { getSupabaseBrowserClient } =
    await import("@/integrations/supabase/supabaseClient");
  const supabase = getSupabaseBrowserClient();
  const { data, error } = await supabase.functions.invoke<PurgeResponseBody>(
    "admin-purge-user-data",
    { method: "POST", body: {} },
  );
  if (error) {
    return { ok: false, reason: error.message };
  }
  if (!data || data.ok !== true) {
    return {
      ok: false,
      reason: data?.reason ?? data?.error ?? "purge-failed",
      deletedScopes: data?.deletedScopes,
    };
  }
  return { ok: true, deletedScopes: data.deletedScopes };
}
